module.exports = __webpack_public_path__ + "img/4-rectangle-6-2@2x.80d5f571.png";